import { render, staticRenderFns } from "./SelectMulti.vue?vue&type=template&id=5b80aaaf&"
import script from "./SelectMulti.js?vue&type=script&lang=js&"
export * from "./SelectMulti.js?vue&type=script&lang=js&"
import style0 from "./SelectMulti.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports